"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _withStateHandlers2 = _interopRequireDefault(require("recompose/withStateHandlers"));

var _upperFirst = _interopRequireDefault(require("lodash/upperFirst"));

var _isFunction = _interopRequireDefault(require("lodash/isFunction"));

var _default = function _default(name, initialState) {
  var _withStateHandlers;

  if (initialState === void 0) {
    initialState = false;
  }

  return (0, _withStateHandlers2["default"])(function (props) {
    var _ref;

    return _ref = {}, _ref[name + "Showing"] = (0, _isFunction["default"])(initialState) ? initialState(props) : initialState, _ref;
  }, (_withStateHandlers = {}, _withStateHandlers["onSet" + (0, _upperFirst["default"])(name)] = function onSet() {
    return function (value) {
      var _ref2;

      return _ref2 = {}, _ref2[name + "Showing"] = !!value, _ref2;
    };
  }, _withStateHandlers["onShow" + (0, _upperFirst["default"])(name)] = function onShow() {
    return function () {
      var _ref3;

      return _ref3 = {}, _ref3[name + "Showing"] = true, _ref3;
    };
  }, _withStateHandlers["onHide" + (0, _upperFirst["default"])(name)] = function onHide() {
    return function () {
      var _ref4;

      return _ref4 = {}, _ref4[name + "Showing"] = false, _ref4;
    };
  }, _withStateHandlers["onToggle" + (0, _upperFirst["default"])(name)] = function onToggle(state) {
    return function () {
      var _ref5;

      return _ref5 = {}, _ref5[name + "Showing"] = !state[name + "Showing"], _ref5;
    };
  }, _withStateHandlers));
};

exports["default"] = _default;